import { MapperBase } from '../../utilities/mapper-base';
import { ProcessingActiveStepDetailsResponseResource } from '../resource/processing-active-step-details-response.resource';
import { ProcessingStep } from '../ui/processing-step.model';

export class ProcessingActiveStepDetailsResponseResourceToProcessingStepMapper extends MapperBase<ProcessingActiveStepDetailsResponseResource, ProcessingStep> {
	map(source: ProcessingActiveStepDetailsResponseResource): ProcessingStep {
		const dest = new ProcessingStep();
		dest.id = source.id;
		dest.stepParams = source.stepParams;
		dest.caseId = source.caseId;
		dest.caseName = source.caseName;
		dest.createdDateTime = source.createdDateTime;
		dest.serverIpAddress = source.serverIpAddress;
		dest.serverInstanceName = source.serverInstanceName;
		dest.functionName = source.functionName;
		dest.pageCount = source.pageCount;
		dest.documentName = source.documentName;
		dest.documentSize = source.documentSize;
		dest.documentId = source.documentId;
		return dest;
	}
}
